
import Bucket from "../../../assets/duotone/Bucket.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BucketIcon({ className, dataTestid = "BucketIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bucket data-testid={dataTestid} className={classes} {...rest} />
  );
}
